module.exports = __webpack_public_path__ + "static/media/light_and_fresh_air.e6307614.svg";